export const LOGO_PATH = '/assets';
export const LOGO_EXTENSION = 'png';
